// extracted by mini-css-extract-plugin
module.exports = {"container":"_cR","image":"_cS","imageLink":"_cT","content":"_cU","title":"_cV","link":"_cW","itemWithIcon":"_cX","text":"_cY","linkTitle":"_cZ","description":"_c0","button":"_c1"};